import { Sparkles, Globe, Zap, BarChart, Shield } from "lucide-react";

export const features = [
  {
    icon: Sparkles,
    title: "Génération IA",
    description: "Créez des contenus SEO optimisés en quelques minutes.",
  },
  {
    icon: Globe,
    title: "Support multilingue",
    description: "Rédigez dans plusieurs langues pour un public mondial.",
  },
  {
    icon: Zap,
    title: "Mots-clés intelligents",
    description: "Intégrez automatiquement les mots-clés pertinents avec la bonne densité.",
  },
  {
    icon: BarChart,
    title: "Analyses de performance",
    description: "Suivez les résultats SEO de vos contenus.",
  },
  {
    icon: Shield,
    title: "Contenu unique",
    description: "Garantie sans plagiat pour chaque article.",
  },
];

export type Feature = (typeof features)[number];
